/**
 * /admin/revenue - the route.
 *
 * The page itself lives in components/admin/revenue, split by zone the same way
 * the member record page is split by section. It used to be a single 992-line
 * route file holding the header, seven KPIs, four chart series, the plan mix,
 * two list cards and a drift strip.
 */
import { createFileRoute } from '@tanstack/react-router';
import { RevenuePage } from '@/components/admin/revenue/RevenuePage';

export const Route = createFileRoute('/admin/revenue')({
  component: RevenuePage,
});

// NOTE: nothing else may be exported from a route file. The TanStack
// code-splitting plugin rewrites `component` into a lazy import and drops the
// import it came from, so a re-export here compiles to an undefined binding.
// Import the page from its own module instead.
